export enum SessionPath {
  DOMAINE = 'Session',
  DOCUMENTS = 'documents',
  DOCUMENT_OLD = 'documents_old',
  ROOT = '',
  EDITION = 'edition-session',
  EDITION_GENERAL = 'general',
  CONTRATS = 'contrats',
  LISTE_INSCRIPTIONS = 'inscriptions',
  CREATION = 'creation-session',
  ID_SESSION_PARAM = 'IdSession',
  LISTE_SEANCES = 'seances',
  TARIFS = 'tarifs',
  CREATION_SEANCE = 'creation-seance',
  EDITION_SEANCE = 'edition-seance',
  CREATION_INSCRIPTION = 'creation-inscription',
  CREATION_MULTI_INSCRIPTION = 'creation-multi-inscription',
  EDITION_INSCRIPTION = 'edition-inscription',
  FACTURES = 'factures',
  EDITION_BROUILLON_FACTURE = 'edition-brouillon',
  VISUALISE_FACTURE = 'visualise-facture',
  RESUME_SESSION = 'resume-session',
  CREATION_CONTRAT = 'creation-contrat',
  EDITION_CONTRAT = 'edition-contrat',
  BUDGET = 'budget',
}
